import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataService } from "../../../../services/data.service";
import { SpinnerService } from "shared-components";
import { TranslateService } from "@ngx-translate/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";

@Component({
  selector: "app-grid-avisos-designaciones",
  templateUrl: "./grid-avisos-designaciones.component.html",
})
export class GridAvisosDesignacionesComponent implements OnInit {
  private readonly _DEFAULT_ITEMS_PER_PAGE = 5;

  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 1;
  public totalItems: number;
  public firstItemList = 0;
  public lastItemList = this.itemsPerPage;
  public readonly visiblePages = 3;

  public labels;
  public data;
  public dataDisplayed;
  public dataExpedicionCeroDias;
  public dataExpedicionCeroDiasDisplayed;

  public showExpedicionCero = false;
  public showExpedicionDesignados = false;
  public showDesignadosAforo = false;
  public showDesignacionesDeshabilitadas = false;
  public showDesignacionesFinalizadas = false;

  public columnId: number;

  @Input() titulo: string;
  @Input() dataExpedicionCero?;

  @Output() refresh = new EventEmitter<boolean>();
  @Output() emitDataExpedicionCero = new EventEmitter<any>();

  filtersVisible = false;
  public filtersForm: FormGroup;
  public paises: any;
  public denominaciones: any;
  public etiquetadores: any;
  public fincas: any;
  public productores: any;

  public entryForm = 5;

  constructor(
    private readonly fb: FormBuilder,
    private readonly _translate: TranslateService,
    private readonly _dataService: DataService,
    private readonly _spinnerService: SpinnerService,
    private readonly _sessionContext: SessionContextService
  ) {
    this.filtersForm = this.fb.group({});
  }

  ngOnInit() {
    if (!this.reuseExpedicionCeroData()) {
      this.expedicionCeroTable();
      this.expedicionDesignadosTable();
      this.designadosAforoTable();
      this.designacionesDeshabilitadasTable();
      this.designacionesFinalizadasTable();
    }

    this.configureFilters();
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public get isSmallScreen() {
    return this._sessionContext.isSmallScreen();
  }

  private reuseExpedicionCeroData() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.expedicionCero.label"
      ) +
        " " +
        this._translate.instant(
          "central-avisos.designaciones.expedicionCero.subLabel30"
        )
    ) {
      if (this.dataExpedicionCero) {
        this.dataExpedicionCeroDias =
          this.dataExpedicionCero.lsCeroKg_30Dias.lista;
        this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
        this.totalItems =
          this.dataExpedicionCero.lsCeroKg_30Dias.paginacionMeta.totalCount;
        this.showExpedicionCero = true;
        this.fillMultis();
        return true;
      }
    } else if (
      this.titulo ===
        this._translate.instant(
          "central-avisos.designaciones.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.designaciones.expedicionCero.subLabel45"
          ) &&
      this.dataExpedicionCero
    ) {
      this.dataExpedicionCeroDias =
        this.dataExpedicionCero.lsCeroKg_45Dias.lista;
      this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
      this.totalItems =
        this.dataExpedicionCero.lsCeroKg_45Dias.paginacionMeta.totalCount;
      this.showExpedicionCero = true;
      this.fillMultis();
      return true;
    } else if (
      this.titulo ===
        this._translate.instant(
          "central-avisos.designaciones.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.designaciones.expedicionCero.subLabel60"
          ) &&
      this.dataExpedicionCero
    ) {
      this.dataExpedicionCeroDias =
        this.dataExpedicionCero.lsCeroKg_60Dias.lista;
      this.totalItems =
        this.dataExpedicionCero.lsCeroKg_60Dias.paginacionMeta.totalCount;
      this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
      this.showExpedicionCero = true;
      this.fillMultis();
      return true;
    } else {
      return false;
    }
  }

  private getExpedicionCeroGrid() {
    this.showExpedicionCero = true;
    this._spinnerService.showSpinner();
    const filters = {};
    this._dataService
      .getKilosExpedicionCeroDesignacionesTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.data = resp;
          if (
            this.titulo ===
            this._translate.instant(
              "central-avisos.designaciones.expedicionCero.label"
            ) +
              " " +
              this._translate.instant(
                "central-avisos.designaciones.expedicionCero.subLabel30"
              )
          ) {
            this.dataExpedicionCeroDias = resp.lsCeroKg_30Dias.lista;
            this.totalItems = resp.lsCeroKg_30Dias.paginacionMeta.totalCount;
            this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
            this.fillMultis();
          } else if (
            this.titulo ===
            this._translate.instant(
              "central-avisos.designaciones.expedicionCero.label"
            ) +
              " " +
              this._translate.instant(
                "central-avisos.designaciones.expedicionCero.subLabel45"
              )
          ) {
            this.dataExpedicionCeroDias = resp.lsCeroKg_45Dias.lista;
            this.totalItems = resp.lsCeroKg_45Dias.paginacionMeta.totalCount;
            this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
            this.fillMultis();
          } else if (
            this.titulo ===
            this._translate.instant(
              "central-avisos.designaciones.expedicionCero.label"
            ) +
              " " +
              this._translate.instant(
                "central-avisos.designaciones.expedicionCero.subLabel60"
              )
          ) {
            this.dataExpedicionCeroDias = resp.lsCeroKg_60Dias.lista;
            this.totalItems = resp.lsCeroKg_60Dias.paginacionMeta.totalCount;
            this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
            this.fillMultis();
          }
        }
        /* this.fillMultiExpedicionCero(); */
      });
  }

  private getExpedicionDesignadosGrid(porcentajes, operador) {
    let filters;
    this.showExpedicionDesignados = true;
    if (operador === "=") {
      filters = {
        operadorIgualdad: true,
      };
    } else {
      filters = {
        porcentajeMin: porcentajes.min ? porcentajes.min : null,
        porcentajeMax: porcentajes.max ? porcentajes.max : null,
      };
    }
    this._spinnerService.showSpinner();
    this._dataService
      .getKilosExpedicionRespectoDesignadosDesignacionesTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          this.fillMultis();
        }
      });
  }

  private getDesignadosAforoGrid(porcentajes, operador) {
    let filters;
    this.showDesignadosAforo = true;
    filters = {
      porcentajeMin: porcentajes.min ? porcentajes.min : null,
      porcentajeMax: porcentajes.max ? porcentajes.max : null,
    };

    this._spinnerService.showSpinner();
    this._dataService
      .getKilosDesignadosRespectoAforoDesignacionesTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          this.fillMultis();
        }
      });
  }

  public getDesignacionesDeshabilitadas() {
    let filters = {
      inpresionAutorizada: true,
    };
    this.showDesignacionesDeshabilitadas = true;
    this._spinnerService.showSpinner();
    this._dataService
      .getDesignacionesDeshabilitadasTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          this.fillMultis();
        }
      });
  }

  public getDesignacionesFinalizadas() {
    let filters = {
      finalizada: true,
    };
    this.showDesignacionesFinalizadas = true;
    this._spinnerService.showSpinner();
    this._dataService
      .getDesignacionesFinalizadasTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          this.fillMultis();
        }
      });
  }

  public pageChange(page) {
    this.currentPage = page;
    this.firstItemList = this.itemsPerPage * (page - 1);
    this.lastItemList = this.itemsPerPage * page;
    //this.showCorrectTable();
  }

  public itemsPerPageChange(items) {
    this.currentPage = 1;
    this.itemsPerPage = items;
    this.firstItemList = 0;
    this.lastItemList = items;
    //this.showCorrectTable();
  }

  public expedicionCeroTable() {
    if (
      this.titulo ===
        this._translate.instant(
          "central-avisos.designaciones.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.designaciones.expedicionCero.subLabel30"
          ) ||
      this.titulo ===
        this._translate.instant(
          "central-avisos.designaciones.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.designaciones.expedicionCero.subLabel45"
          ) ||
      this.titulo ===
        this._translate.instant(
          "central-avisos.designaciones.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.designaciones.expedicionCero.subLabel60"
          )
    ) {
      this.getExpedicionCeroGrid();
    }
  }

  public expedicionDesignadosTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.expedicionDesignados.preLabel"
      ) +
        "=" +
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionDesignados.postLabel"
        ) +
        " "
    ) {
      this.getExpedicionDesignadosGrid({}, "=");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.expedicionDesignados.preLabel"
      ) +
        "<" +
        this._translate.instant(
          "central-avisos.designaciones.expedicionDesignados.postLabel"
        ) +
        " (<50%)"
    ) {
      this.getExpedicionDesignadosGrid({ min: null, max: 50 }, "<");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.expedicionDesignados.preLabel"
      ) +
        "<" +
        this._translate.instant(
          "central-avisos.designaciones.expedicionDesignados.postLabel"
        ) +
        " (50%-75%)"
    ) {
      this.getExpedicionDesignadosGrid({ min: 50, max: 75 }, "<");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.expedicionDesignados.preLabel"
      ) +
        ">" +
        this._translate.instant(
          "central-avisos.designaciones.expedicionDesignados.postLabel"
        ) +
        " (15%-20%)"
    ) {
      this.getExpedicionDesignadosGrid({ min: 115, max: 120 }, ">");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.expedicionDesignados.preLabel"
      ) +
        ">" +
        this._translate.instant(
          "central-avisos.designaciones.expedicionDesignados.postLabel"
        ) +
        " (20%-25%)"
    ) {
      this.getExpedicionDesignadosGrid({ min: 120, max: 125 }, ">");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.expedicionDesignados.preLabel"
      ) +
        ">" +
        this._translate.instant(
          "central-avisos.designaciones.expedicionDesignados.postLabel"
        ) +
        " (>25%)"
    ) {
      this.getExpedicionDesignadosGrid({ min: 125, max: null }, ">");
    }
  }

  public designadosAforoTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.designadosAforo.preLabel"
      ) +
        "<" +
        this._translate.instant(
          "central-avisos.designaciones.designadosAforo.postLabel"
        ) +
        " (<90%)"
    ) {
      this.getDesignadosAforoGrid({ min: null, max: 90 }, "<");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.designadosAforo.preLabel"
      ) +
        "<" +
        this._translate.instant(
          "central-avisos.designaciones.designadosAforo.postLabel"
        ) +
        " (90%-99%)"
    ) {
      this.getDesignadosAforoGrid({ min: 90, max: 99 }, "<");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.designadosAforo.preLabel"
      ) +
        ">" +
        this._translate.instant(
          "central-avisos.designaciones.designadosAforo.postLabel"
        ) +
        " (1%-10%)"
    ) {
      this.getDesignadosAforoGrid({ min: 101, max: 110 }, ">");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.designadosAforo.preLabel"
      ) +
        ">" +
        this._translate.instant(
          "central-avisos.designaciones.designadosAforo.postLabel"
        ) +
        " (>10%)"
    ) {
      this.getDesignadosAforoGrid({ min: 110, max: null }, ">");
    }
  }

  public designacionesDeshabilitadasTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.designacionesDeshabilitadas.label"
      ) +
        " "
    ) {
      this.getDesignacionesDeshabilitadas();
    }
  }

  public designacionesFinalizadasTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.designaciones.designacionesFinalizadas.label"
      ) +
        " "
    ) {
      this.getDesignacionesFinalizadas();
    }
  }

  public showCorrectTable() {
    if (this.showExpedicionCero) {
      this.expedicionCeroTable();
    } else if (this.showExpedicionDesignados) {
      this.expedicionDesignadosTable();
    } else if (this.showDesignadosAforo) {
      this.designadosAforoTable();
    } else if (this.showDesignacionesDeshabilitadas) {
      this.designacionesDeshabilitadasTable();
    } else if (this.showDesignacionesFinalizadas) {
      this.designacionesFinalizadasTable();
    }
  }

  public close() {
    this.refresh.emit(true);

    if (
      this.titulo ===
        this._translate.instant(
          "central-avisos.designaciones.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.designaciones.expedicionCero.subLabel30"
          ) ||
      this.titulo ===
        this._translate.instant(
          "central-avisos.designaciones.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.designaciones.expedicionCero.subLabel45"
          ) ||
      this.titulo ===
        this._translate.instant(
          "central-avisos.designaciones.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.designaciones.expedicionCero.subLabel60"
          )
    ) {
      this.emitDataExpedicionCero.emit(this.data);
    } else {
      this.emitDataExpedicionCero.emit();
    }
  }

  public toOrderBy(id: number) {
    this.columnId = id;
  }

  public getSortIcon(id: number) {
    let iconClass = "fa fa-sort";
    if (id === this.columnId) {
      const selectedColumn = document.querySelectorAll("th")[id - 1];
      iconClass =
        selectedColumn.dataset.order === "desc"
          ? "fa fa-sort-up"
          : "fa fa-sort-down";
    }
    return iconClass;
  }

  // FILTERS

  fillMultis() {
    this.paises = this.getUniqueValues(
      this.showExpedicionCero ? this.dataExpedicionCeroDias : this.data,
      "desPais",
      "paisId"
    );
    this.denominaciones = this.getUniqueValues(
      this.showExpedicionCero ? this.dataExpedicionCeroDias : this.data,
      "desDenominacion",
      "denominacionId"
    );
    this.fincas = this.getUniqueValues(
      this.showExpedicionCero ? this.dataExpedicionCeroDias : this.data,
      "desFinca",
      "fincaId"
    );
    this.productores = this.getUniqueValues(
      this.showExpedicionCero ? this.dataExpedicionCeroDias : this.data,
      "desProductor",
      "productorId"
    );
    this.etiquetadores = this.getUniqueValues(
      this.showExpedicionCero ? this.dataExpedicionCeroDias : this.data,
      "desEtiquetador",
      "etiquetadorId"
    );
  }

  shareCheckedListPaises(item: any[]) {
    this.filtersForm.get("pais").patchValue(item);
  }

  shareCheckedListDenominaciones(item: any[]) {
    this.filtersForm.get("denominacion").patchValue(item);
  }

  shareCheckedListFincas(item: any[]) {
    if (item) {
      this.filtersForm.get("finca").patchValue(item);
    }
  }

  shareCheckedListProductores(item: any[]) {
    if (item) {
      this.filtersForm.get("productor").patchValue(item);
    }
  }

  shareCheckedListEtiquetadores(item: any[]) {
    this.filtersForm.get("etiquetador").patchValue(item);
  }

  clearFormGroup(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) =>
      formGroup.removeControl(key)
    );
  }

  /* In this function we are also setting the entry form */

  private configureFilters() {
    // Clear formGroup before add new controls.
    this.clearFormGroup(this.filtersForm);

    this.filtersForm.addControl("pais", new FormControl([]));
    this.filtersForm.addControl("denominacion", new FormControl([]));
    this.filtersForm.addControl("finca", new FormControl([]));
    this.filtersForm.addControl("productor", new FormControl([]));
    this.filtersForm.addControl("etiquetador", new FormControl([]));

    if (this.showExpedicionDesignados || this.showDesignadosAforo) {
      this.filtersForm.addControl("porcentajeEtiquetado", new FormControl(""));
      this.entryForm = 6;
    }

    if (this.showDesignacionesDeshabilitadas) {
      this.filtersForm.addControl("bloqueoDesde", new FormControl(""));
      this.filtersForm.addControl("bloqueoHasta", new FormControl(""));
      this.entryForm = 7;
    }
  }

  public filtrar() {
    const selectedPaises = this.filtersForm.get("pais")?.value;
    const selectedDenominaciones = this.filtersForm.get("denominacion")?.value;
    const selectedFincas = this.filtersForm.get("finca")?.value;
    const selectedProductores = this.filtersForm.get("productor")?.value;
    const selectedEtiquetadores = this.filtersForm.get("etiquetador")?.value;
    const porcentajeEtiquetado = this.filtersForm.get(
      "porcentajeEtiquetado"
    )?.value;
    const bloqueoDesde = this.filtersForm.get("bloqueoDesde")?.value;
    const bloqueoHasta = this.filtersForm.get("bloqueoHasta")?.value;

    // Reset displayed data && filter data
    if (this.showExpedicionCero) {
      this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;

      if (selectedPaises && selectedPaises.length > 0) {
        this.dataExpedicionCeroDiasDisplayed = this.filterDataByIds(
          this.dataExpedicionCeroDiasDisplayed,
          selectedPaises,
          "paisId"
        );
      }

      if (selectedDenominaciones && selectedDenominaciones.length > 0) {
        this.dataExpedicionCeroDiasDisplayed = this.filterDataByIds(
          this.dataExpedicionCeroDiasDisplayed,
          selectedDenominaciones,
          "denominacionId"
        );
      }

      if (selectedFincas && selectedFincas.length > 0) {
        this.dataExpedicionCeroDiasDisplayed = this.filterDataByIds(
          this.dataExpedicionCeroDiasDisplayed,
          selectedFincas,
          "fincaId"
        );
      }

      if (selectedProductores && selectedProductores.length > 0) {
        this.dataExpedicionCeroDiasDisplayed = this.filterDataByIds(
          this.dataExpedicionCeroDiasDisplayed,
          selectedProductores,
          "productorId"
        );
      }

      if (selectedEtiquetadores && selectedEtiquetadores.length > 0) {
        this.dataExpedicionCeroDiasDisplayed = this.filterDataByIds(
          this.dataExpedicionCeroDiasDisplayed,
          selectedEtiquetadores,
          "etiquetadorId"
        );
      }
    } else {
      this.dataDisplayed = this.data;

      if (selectedPaises && selectedPaises.length > 0) {
        this.dataDisplayed = this.filterDataByIds(
          this.dataDisplayed,
          selectedPaises,
          "paisId"
        );
      }

      if (selectedDenominaciones && selectedDenominaciones.length > 0) {
        this.dataDisplayed = this.filterDataByIds(
          this.dataDisplayed,
          selectedDenominaciones,
          "denominacionId"
        );
      }

      if (selectedFincas && selectedFincas.length > 0) {
        this.dataExpedicionCeroDiasDisplayed = this.filterDataByIds(
          this.dataExpedicionCeroDiasDisplayed,
          selectedFincas,
          "fincaId"
        );
      }

      if (selectedProductores && selectedProductores.length > 0) {
        this.dataExpedicionCeroDiasDisplayed = this.filterDataByIds(
          this.dataExpedicionCeroDiasDisplayed,
          selectedProductores,
          "productorId"
        );
      }

      if (selectedEtiquetadores && selectedEtiquetadores.length > 0) {
        this.dataDisplayed = this.filterDataByIds(
          this.dataDisplayed,
          selectedEtiquetadores,
          "etiquetadorId"
        );
      }

      if (porcentajeEtiquetado) {
        this.dataDisplayed = this.filterDataByNumber(
          this.dataDisplayed,
          porcentajeEtiquetado,
          "porcentaje"
        );
      }

      if (bloqueoDesde || bloqueoHasta) {
        this.dataDisplayed = this.filterDataByDateRange(
          this.dataDisplayed,
          bloqueoDesde,
          bloqueoHasta,
          "fechaImpresionDesautorizada"
        );
      }
    }

    // Update paginator table
    this.firstItemList = 0;
    this.currentPage = 1;
    this.lastItemList = this.itemsPerPage;
    this.totalItems = this.showExpedicionCero
      ? this.dataExpedicionCeroDiasDisplayed.length
      : this.dataDisplayed.length;
  }

  private filterDataByIds(data: any[], selectedIds: number[], key: string) {
    if (!selectedIds || selectedIds.length === 0) {
      return data; // Si no hay IDs seleccionados, no filtrar los datos
    }
    return data.filter((item) => selectedIds.includes(item[key]));
  }

  private filterDataByNumber(data: any[], threshold: number, key: string) {
    return data.filter((item) => item[key] > threshold);
  }

  private filterDataByDateRange(
    data: any[],
    startDate: Date,
    endDate: Date,
    key: string
  ) {
    return data.filter((item) => {
      const itemDate = new Date(item[key]);
      if (startDate && endDate) {
        return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
      } else if (startDate) {
        return itemDate >= new Date(startDate);
      } else if (endDate) {
        return itemDate <= new Date(endDate);
      }
      return true;
    });
  }

  private getUniqueValues(data: any[], key: string, idKey: string) {
    // Crea un mapa para almacenar los valores únicos
    const uniqueMap = new Map();

    // Itera sobre los datos y almacena los valores únicos en el mapa
    data.forEach((item, index) => {
      if (item[idKey] === null || item[idKey] === undefined) {
        item[idKey] = index;
      }
      if (
        !uniqueMap.has(item[key]) &&
        item[key] !== null &&
        item[key] !== undefined
      ) {
        uniqueMap.set(item[key], item[idKey]);
      }
    });

    // Convierte el mapa en un array con la estructura deseada
    let uniqueArray = Array.from(uniqueMap, ([des, id]) => ({ id, des }));

    // Ordena el array alfabéticamente por la propiedad 'des'
    uniqueArray.sort((a, b) => {
      if (a.des.toLowerCase() < b.des.toLowerCase()) {
        return -1;
      }
      if (a.des.toLowerCase() > b.des.toLowerCase()) {
        return 1;
      }
      return 0;
    });

    return uniqueArray;
  }
}
